export const PROJECTS = [
  {
    id: "fesch",
    title: "FESCH Elektrotechnik",
    branch: "Handwerk",
    location: "Wuppertal",
    url: "https://www.fesch-elektrotechnik.de/",
    domain: "fesch-elektrotechnik.de",
    image: "/refs/fesch.jpg",
    result: "Mehr qualifizierte Anfragen",
  },
  {
    id: "edithagay",
    title: "Edith Agay",
    branch: "Fashion & Design",
    location: "Wien",
    url: "https://www.edithagay.com/",
    domain: "edithagay.com",
    image: "/refs/edithagay.jpg",
    result: "Editorialer Marken-Auftritt",
  },
  {
    id: "martin",
    title: "KFZ-Sachverständigenbüro Martin",
    branch: "Gutachter",
    location: "Aresing",
    url: "https://www.martin-gutachten.de/",
    domain: "martin-gutachten.de",
    image: "/refs/martin.jpg",
    result: "Soforthilfe-Funnel",
  },
  {
    id: "toni",
    title: "Gutachter Toni",
    branch: "Gutachter",
    location: "Schneverdingen",
    url: "https://www.gutachtertoni.de/",
    domain: "gutachtertoni.de",
    image: "/refs/toni.jpg",
    result: "Anrufe direkt aus der Seite",
  },
  {
    id: "photovoltaik",
    title: "Photovoltaik Pro",
    branch: "Energie",
    location: "Deutschland",
    url: "https://www.photovoltaik-pro.de/",
    domain: "photovoltaik-pro.de",
    image: "/refs/photovoltaik.jpg",
    result: "Beratungsanfragen online",
  },
  {
    id: "wingtsun",
    title: "Wing Tsun Akademie Ronsdorf",
    branch: "Schulen & Akademien",
    location: "Wuppertal",
    url: "https://www.wingtsun-ronsdorf.de/",
    domain: "wingtsun-ronsdorf.de",
    image: "/refs/wingtsun.jpg",
    result: "Probetraining-Buchungen",
  },
];
